import { useEffect, useState } from "react";
import { apiGet } from "../../legacy/services/apiClient";
import { resolveMediaUrl } from "../../utils/resolveMediaUrl";
import MobileSearchCard from "./MobileSearchCard";

const extractBanners = (payload) => {
  const data = payload?.data ?? payload;
  if (Array.isArray(data)) return data;
  if (Array.isArray(data?.value)) return data.value;
  if (Array.isArray(payload?.value)) return payload.value;
  return [];
};

const normalizeBanner = (item = {}) => ({
  id: item.id || item._id || item.banner_type || "mobile-hero",
  type: String(item.banner_type || item.bannerType || item.type || "").toLowerCase(),
  order: Number(item.banner_order ?? item.bannerOrder ?? item.sort_order ?? 0),
  image: item.image_url || item.imageUrl || item.image || "",
  video: item.video_url || item.videoUrl || "",
  title: String(item.title || item.heading || "").trim(),
  subtitle: String(item.subtitle || item.subheading || "").trim(),
  ctaText: String(item.cta_text || item.ctaText || "").trim(),
  ctaLink: String(item.cta_link || item.ctaLink || "").trim(),
  hideText: Boolean(
    item.hide_text || item.hideText || item?.meta?.hide_text || item?.meta?.hideText
  ),
  active: item.is_active !== false && item.isActive !== false && item.active !== false,
});

export default function MobileHero() {
  const [banner, setBanner] = useState(null);

  useEffect(() => {
    let active = true;

    apiGet(`/api/public/hero-banners?_ts=${Date.now()}`)
      .then((payload) => {
        if (!active) return;
        const banners = extractBanners(payload)
          .map(normalizeBanner)
          .filter((item) => item.active && (item.image || item.video))
          .sort((a, b) => a.order - b.order);
        setBanner(banners.find((item) => item.type === "full") || banners[0] || null);
      })
      .catch(() => {
        if (active) setBanner(null);
      });

    return () => {
      active = false;
    };
  }, []);

  const image = resolveMediaUrl(banner?.image, {
    width: 720,
    fit: "inside",
    quality: 76,
  });
  const hasCopy = banner && !banner.hideText && (banner.title || banner.subtitle || banner.ctaText);

  if (!banner) {
    return (
      <section className="hv-section hv-mobile-search-only">
        <MobileSearchCard compact />
      </section>
    );
  }

  return (
    <section className="hv-mobile-home-hero">
      <div className="hv-mobile-home-hero-media">
        {banner.video ? (
          <video autoPlay muted loop playsInline preload="auto" poster={image || undefined}>
            <source src={resolveMediaUrl(banner.video)} />
          </video>
        ) : (
          <img
            src={image}
            alt={banner.title || "Homevilas hero banner"}
            loading="eager"
            decoding="async"
            fetchPriority="high"
          />
        )}
        {hasCopy ? (
          <div className="hv-mobile-home-hero-copy">
            {banner.title ? <h1>{banner.title}</h1> : null}
            {banner.subtitle ? <p>{banner.subtitle}</p> : null}
            {banner.ctaText && banner.ctaLink ? (
              <a href={banner.ctaLink}>{banner.ctaText}</a>
            ) : null}
          </div>
        ) : null}
      </div>
      <div className="hv-mobile-home-hero-search">
        <MobileSearchCard compact />
      </div>
    </section>
  );
}
